import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { smoothScrollTo } from '../utils/smoothScroll';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e, href) => {
    e.preventDefault();
    smoothScrollTo(href);
    setIsMobileMenuOpen(false);
  };

  const navItems = [
    { name: 'Početna', href: '#home' },
    { name: 'O Nama', href: '#about' },
    { name: 'Usluge', href: '#services' },
    { name: 'Projekti', href: '#projects' },
    { name: 'Kontakt', href: '#contact' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="#home" className="flex items-center space-x-2">
            <div className="text-2xl font-bold" style={{ fontFamily: "'Playfair Display', serif" }}>
              <span className={`${
                isScrolled ? 'text-[#0f172a]' : 'text-white'
              }`}>Dekor Art </span>
              <span className="text-[#d4af37]">gradnja</span>
            </div>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <a
                key={item.name}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className={`font-medium transition-colors hover:text-[#d4af37] cursor-pointer ${
                  isScrolled ? 'text-[#0f172a]' : 'text-white'
                }`}
              >
                {item.name}
              </a>
            ))}
            <a
              href="#contact"
              onClick={(e) => handleNavClick(e, '#contact')}
              className="btn-primary px-6 py-2.5 text-sm cursor-pointer"
            >
              Zatražite Ponudu
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? (
              <X className={`w-6 h-6 ${
                isScrolled ? 'text-[#0f172a]' : 'text-white'
              }`} />
            ) : (
              <Menu className={`w-6 h-6 ${
                isScrolled ? 'text-[#0f172a]' : 'text-white'
              }`} />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden pb-4 bg-white rounded-b-lg shadow-lg">
            <nav className="flex flex-col space-y-4 pt-4">
              {navItems.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  onClick={(e) => handleNavClick(e, item.href)}
                  className="text-[#0f172a] hover:text-[#d4af37] font-medium px-4 transition-colors cursor-pointer"
                >
                  {item.name}
                </a>
              ))}
              <a
                href="#contact"
                onClick={(e) => handleNavClick(e, '#contact')}
                className="btn-primary mx-4 text-center cursor-pointer"
              >
                Zatražite Ponudu
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;